import React from 'react';

import { ITabsBaseProps } from 'views/Offers/RollingOffers/Form/RollingOfferForm.types';

import { SubOffersList } from '../SubOfferCard';

const ConfigurationTab: React.FC<ITabsBaseProps> = ({
  rollingOfferId,
  productsSequence,
  setProductsSequence,
  setBarPointsValidity,
  relevantBadgeType
}): React.ReactElement => {
  return (
    <SubOffersList
      rollingOfferId={rollingOfferId}
      productsSequence={productsSequence}
      setProductsSequence={setProductsSequence}
      setBarPointsValidity={setBarPointsValidity}
      relevantBadgeType={relevantBadgeType}
    />
  );
};

export default ConfigurationTab;
